import React from 'react';
import styled, {keyframes} from 'styled-components';
import Refresh from 'modules/common/Svg/Refresh';

const blue = '#357EDD';
const darkBlue = '#00449e';
const BlueRefresh = () => <Refresh color={darkBlue} />;
export const PaymentWrapper = styled.div`
  width: 43rem;
  margin: 2rem 0;
  @media (max-width: 784px) {
    width: 100%;
  }
`;
export const DescriptionWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-content: center;
  margin: 0.5rem 0;
  @media (max-width: 1028px) {
    flex-direction: column;
  }
`;
export const ButtonWrapper = styled.div`
  width: 24.87rem;
`;
export const Button = styled.button`
  color: #fff;
  background-color: ${({disabled}) => (disabled ? '#979797' : blue)};
  width: 100%;
  padding: 1rem 0rem;
  border: none;
  border-radius: 2px;
  cursor: pointer;
  &:hover {
    background-color: ${({disabled}) => (disabled ? '' : darkBlue)};
  }
  @media (max-width: 1028px) {
    align-self: center;
    margin-top: 3rem;
    width: 30rem;
  }
  @media (max-width: 578px) {
    width: 100%;
  }
`;
export const CouponWrapper = styled.div`
  display: flex;
  flex-direction: column;
  div {
    margin-top: 12px;
    display: flex;
  }
  input {
    width: 17rem;
    border: 1px solid #d0d1d3;
    border-radius: 2px;
    margin-left: 12px;
  }
  @media (max-width: 570px) {
    input {
      width: 12rem;
      font-size: 0.8rem;
    }
  }
  @media (max-width: 450px) {
    input {
      width: 65%;
    }
  }
`;
export const ButtonCoupon = styled.button`
  color: #fff;
  background-color: #fff;
  color: ${darkBlue};
  width: 12rem;
  padding: 14px 0rem;
  border: 2px solid ${darkBlue};
  border-radius: 2px;
  cursor: pointer;
  @media (max-width: 570px) {
    width: 10rem;
  }
  @media (max-width: 450px) {
    input {
      width: 35%;
    }
  }
`;
export const SubmitWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: 1.7rem;
  margin-bottom: 4rem;
  @media (max-width: 1028px) {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
  }
`;
const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;
export const Loader = styled(Refresh)`
  width: 16px;
  height: 16px;
  animation: ${rotate} 4s linear infinite;
`;
export const BlueLoader = styled(BlueRefresh)`
  width: 16px;
  height: 16px;
  animation: ${rotate} 4s linear infinite;
`;
export const Line = styled.div`
  width: 100%;
  height: 0;
  margin: 3rem 0;
  border-top: 1px solid #dfe4eb;
`;
export const LoadingMessage = styled.div`
  width: 100%;
  height: 80vh;
  display: flex;
  justify-content: center;
  align-items: center;
  p {
    font-weight: bold;
  }
`;
